import { Box } from "@mui/material";
import TextField from "@mui/material/TextField";
import { WebsiteInformation } from "@repo/server-api";
import { ContactExtended } from "@repo/server-api/types";
import { useTranslation } from "next-i18next";
import React, {
	forwardRef,
	useCallback,
	useEffect,
	useImperativeHandle,
	useMemo,
	useRef,
	useState,
} from "react";
// import * as Yup from "yup";

import { setContactValues } from "@repo/legacy/components/helper/Index";

type Exposed = {
	validate: () => Promise<Record<string, boolean | object | string>>;
};

const OtherCompanySection = forwardRef(
	(
		props: Readonly<{
			contact: ContactExtended | null;
			setContact: (value: ContactExtended) => void;
			errors?: Record<string, boolean | object | string>;
			setErrors?: (value: Record<string, boolean | object | string>) => void;
		}>,
		ref: React.Ref<Exposed>,
	) => {
		const { t } = useTranslation();

		const info = useMemo<ContactExtended>(() => {
			return setContactValues(props.contact);
		}, [props.contact]);

		const [websiteLocal, setWebsiteLocal] = useState("");

		const websiteFocusedRef = useRef(false);

		useEffect(() => {
			if (!websiteFocusedRef.current) {
				const websiteInfo = info.additionalInformation.find(
					(item): item is WebsiteInformation =>
						(item as WebsiteInformation).__typename === "WebsiteInformation",
				) as WebsiteInformation | undefined;
				setWebsiteLocal(websiteInfo?.url ?? "");
			}
		}, [info]);

		// const validationSchema = Yup.object().shape({});

		const validateFields = useCallback(async () => {
			const localErrors: Record<string, boolean | object | string> = {};

			return localErrors;
		}, [props]);

		useImperativeHandle(ref, () => ({
			validate: validateFields,
		}));

		return (
			<div>
				<Box>
					<TextField
						onChange={(event) => {
							const v = event.target.value ?? "";
							setWebsiteLocal(v);
							const websiteInfo = info.additionalInformation.find(
								(item): item is WebsiteInformation =>
									(item as WebsiteInformation).__typename === "WebsiteInformation",
							);
							props.setContact?.({
								...info,
								additionalInformation: [
									...info.additionalInformation.filter(
										(item): item is WebsiteInformation =>
											(item as WebsiteInformation).__typename !== "WebsiteInformation",
									),
									{
										id: websiteInfo ? websiteInfo.id : "",
										__typename: "WebsiteInformation",
										url: v,
									} as WebsiteInformation,
								],
							});
						}}
						onFocus={() => {
							websiteFocusedRef.current = true;
						}}
						onBlur={() => {
							websiteFocusedRef.current = false;
						}}
						value={websiteLocal}
						label={t("website")}
						variant="outlined"
						sx={{ width: "100%", mt: 2.5 }}
					/>
				</Box>
			</div>
		);
	},
);

OtherCompanySection.displayName = "OtherCompanySection";
export default OtherCompanySection;
